import React from "react";
import { Card, CardBody } from "../card/card.jsx";

const CardLoader = ({
  title = "Loading...",
  icon = null,
  info = [],
  chartType = "bar",
  chartHeight = 60,
  spinnerHeight = 60,
  className = "",
  style = {},
  spinnerColor = "var(--bs-theme)",
  themeColor
}) => {
  return (
    <Card className={`mb-3 ${className}`} style={style}>
      <CardBody>
        <div className="d-flex fw-bold small mb-3 align-items-center">
          {icon && <span className="me-2">{icon}</span>}
          <span className="flex-grow-1">{title}</span>
        </div>
        {/* Stat & Chart Placeholders */}
        <div className="row align-items-center mb-2">
          <div className="col-7">
            <h3 className="mb-0">
              <div
                className="spinner-border"
                role="status"
                style={{
                  color: themeColor,
                  width: "2.5rem",
                  height: "2.5rem",
                }}
              >
                <span className="visually-hidden">Loading stat...</span>
              </div>
            </h3>
          </div>
          <div className="col-5">
            <div className="mt-n2 position-relative" style={{ minHeight: chartHeight }}>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: spinnerHeight }}
              >
                <div
                  className="spinner-border"
                  role="status"
                  style={{
                    color: themeColor,
                    width: "2.5rem",
                    height: "2.5rem",
                  }}
                >
                  <span className="visually-hidden">Loading chart...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="small text-inverse text-opacity-50 text-truncate">
          {info.map((item, idx) => (
            <div key={idx}>
              {item.icon && <i className={item.icon} />} {item.text || ""}
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default CardLoader;
